import React, { forwardRef, useEffect, useRef } from 'react';

import { IndeterminateCheckboxProps } from 'directory/listings/notification-modals/types';

import 'directory/listings/notification-modals/components/IndeterminateCheckbox/IndeterminateCheckbox.scss';

export const IndeterminateCheckbox = forwardRef<HTMLInputElement, IndeterminateCheckboxProps>(
    ({ indeterminate, className = '', ...rest }, ref) => {
        const defaultRef = useRef<HTMLInputElement>(null);
        const resolvedRef: any = ref || defaultRef;

        useEffect(() => {
            if (resolvedRef.current) {
                resolvedRef.current.indeterminate = indeterminate || false;
            }
        }, [resolvedRef, indeterminate]);

        return <input type="checkbox" ref={resolvedRef} className={`indeterminate-checkbox ${className}`} {...rest} />;
    },
);

IndeterminateCheckbox.displayName = 'IndeterminateCheckbox';
